import React from "react";
import { API_ENDPOINTS } from "config/apiConfig";
import { Delete, InquiryFilter, InquiryListPaginate } from "common/interfaces";
import { PAGINATION } from "common/enums/Pagination.enum";
import { baseApi } from "./baseApi";

export const inquiryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Inquiry
    getInquiries: builder.query<
      InquiryListPaginate,
      { filter?: InquiryFilter; page?: number; limit?: number }
    >({
      query: ({ filter, page, limit }) => ({
        url: API_ENDPOINTS.CONVERSATION_INQUIRY,
        params: {
          page: page || PAGINATION.PAGE,
          limit: limit || PAGINATION.LIMIT,
          ...filter,
        },
      }),
      providesTags: ["Inquiry"],
    }),

    // Delete Inquiry
    deleteInquiry: builder.mutation<Delete, React.Key[]>({
      query: (codes) => ({
        url: API_ENDPOINTS.CONVERSATION_INQUIRY_DELETE,
        method: "DELETE",
        body: { codes },
      }),
      invalidatesTags: ["Inquiry"],
    }),

    // Download CSV
    downloadInquiryCsv: builder.mutation<
      Blob,
      { filter: InquiryFilter; fileName: string }
    >({
      query: ({ filter, fileName }) => ({
        url: API_ENDPOINTS.CONVERSATION_INQUIRY_CSV,
        method: "GET",
        params: filter,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          return blob;
        },
      }),
    }),
  }),
});

export const {
  useGetInquiriesQuery,
  useDeleteInquiryMutation,
  useDownloadInquiryCsvMutation,
} = inquiryApi;
